import { DATE_FORMAT } from './../constants/constant';
import { Pipe, PipeTransform } from '@angular/core';
import * as moment from "moment";

@Pipe({
  name: 'datePipe'
})
export class DatePipePipe implements PipeTransform {

  transform(date: Date | string, format: string = DATE_FORMAT): string {
    return moment(date).format(format);;
  }

}
